/**
 * Vendor (Trail Stops) Mapping.
 *
 * @category   JavaScript
 * @subpackage CulinaryTrailsAssetsManager
 * @author     Jason D. Moss <jason@jdmlabs.com>
 * @copyright  2017 Taste of Nova Scotia. All rights reserved.
 * @link       https://novascotiaculinarytrails.com/
 */


var XHRq;
var activeTrail;
var vendorData = [];
var infoBoxAnim = (window.matchMedia("(min-width:1020px)").matches) ? "shake" : "bounce";


/* -- */



/*
 * Configuration object so that other developers can use and extend the script.
 *
 * --------------------------------------------------------------------------- *
 */
var mapConfig = {
    html: {
        noInfo: "<br><br><h5>Sorry, there is nothing to display.</h5>",
    },
    icons: {
        goodcheer: serverDomain +"/wp-content/themes/trails/assets/images/map/pin_goodcheer.png",
        // seafood: serverDomain +"/wp-content/themes/trails/assets/images/map/pin_seafood.png"
    },
    map: {
        mapElementId: "trailMap",
        initialZoom: 10,
        maxZoom: 20,
        mapTypeId: google.maps.MapTypeId.ROAD_MAP,
        animation: google.maps.Animation.DROP,
        disableDefaultUI: true,
        latMultiplier: 1.0,      /* Centering in viewport.                      */
        lngMultiplier: 1.0,       /* Zoom threshhold when viewing single vendor. */
        // styles: $('.map__container').data('tile-style'),
    }
};


/**
 * ...
 *
 * @param {Object} mapConfig
 *
 * @return {Object} that
 *
 * --------------------------------------------------------------------------- *
 */
var mappingApp = (function (mapConfig) {
    "use strict";

    var that = {};
    var map = {};
    var filter = {};
    var markersOnMap = [];
    var currentlyDisplayedMarker;

    that.markers = [];

    /**
     * Initialize our map.
     */
    var initGoogleMaps = function () {
        var mapOptions = {
            center: new google.maps.LatLng(45.159, -63.193),
            zoom: mapConfig.map.initialZoom,
            disableDefaultUI: mapConfig.map.disableDefaultUI,
            fullscreenControl: true,
            scaleControl: true,
            scrollwheel: false,
            streetViewControl: true,
            zoomControl: true,
            mapTypeId: mapConfig.map.mapTypeId,
            maxZoom: mapConfig.map.maxZoom,

            styles: [{
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": 100
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#C6E2FF"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#C5E3BF"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#D1D1B8"
                            }
                        ]
                    }],
        };

        map = new google.maps.Map(document.getElementById(mapConfig.map.mapElementId), mapOptions);
        google.maps.event.addDomListener(window, "resize", function () {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });
    };


    /**
     * Add click handlers to our filters.
     */
    var addEventsToFilters = function () {
        var activeClass = "active";

        /**
         * Click handler function.
         *
         * @param {Object} self
         * @param {String} property
         *
         * @returns {Method}
         */

        var my_handler = function (self, property) {
            
            return function () {
                var obj = self;
                var control = document.getElementById(property);

                [].slice.call(control.querySelectorAll("li")).map(function (option, index) {
                    option.classList.remove(activeClass);
                });

                obj.classList.add(activeClass);

                filter[property] = obj.dataset.value;

                updateMarkersOnMap();
            };
        };


        /**
         * Loop through each different filter.
         */

        [].slice.call(document.querySelectorAll(".filter")).map(function (control, index) {
            var defaultVal;

            /* Add the new filter type. */
            var property = control.getAttribute("id");
            filter[property] = defaultVal;

            /* Attach handlers. */
            [].slice.call(control.querySelectorAll("li")).map(function (option, index) {
                option.addEventListener("click", my_handler(option, property), false);
            });
        });
    };


    /**
     * ...
     *
     * @param {Object} filter
     */
    var setMarkersOnMap = function (filter) {
        /**
         * Filter results based un current URL: Good Cheer or Seafood.
         */
        // if (filter.trail === undefined) {
        //     if (activeTrail === "goodcheer") {
        //         filter.trail = "goodcheer";
        //     }
        // }

        //     if (activeTrail === "seafood") {
        //         filter.trail = "seafood";
        //     }
        // }
        // filter.trail = "goodcheer";
        filter.trail = "All";

        
        var filteredMarkers = MapModel.getMarkers(filter);

        var markersToPlace = filteredMarkers.filter(function (item) {
            return markersOnMap.indexOf(item) === -1;
        });
        var markersToRemove = markersOnMap.filter(function (item) {
            return filteredMarkers.indexOf(item) === -1;
        });

        /* Remove all of the markers we need removed. */
        removeMarkers(markersToRemove);

        /* Place all of the new markers. */
        for (var i = 0, length = markersToPlace.length; i < length; i += 1) {
            markersToPlace[i].setMap(map);
            markersToPlace[i].setAnimation(google.maps.Animation.DROP);
        }

        markersOnMap = filteredMarkers;
    };


    /**
     * ...
     *
     * @param {Array} markers
     */
    var removeMarkers = function (markers) {
        var i, length;
        for (i = 0, length = markers.length; i < length; i += 1) {
            markers[i].setMap(null);
        }

        resetIcons(markers);
    };


    /**
     * ...
     *
     * @param {Object} marker
     *
     * @returns {Boolean}
     */
    var isMarkerOnMap = function (marker) {
        var i, length;
        var onMap = false;
        for (i = 0, length = markersOnMap.length; i < length && !onMap; i += 1) {
            if (marker === markersOnMap[i]) {
                onMap = true;
            }
        }

        return onMap;
    };


    /**
     * ...
     */
    var updateMarkersOnMap = function () {
        /**
         * Update the markers.
         */
        setMarkersOnMap(filter);

        if (markersOnMap.length > 0) {
            /**
             * If the currently selected marker has just been removed, we need
             * to change the selected marker.
             */
            if (!isMarkerOnMap(currentlyDisplayedMarker)) {
                that.selectMarker(markersOnMap[0]);
            }

            /**
             * Resize the bounds so that they fit around all of the available
             * points.
             */
            fitBounds();
        } else {
            currentlyDisplayedMarker = null;

            that.updateInformation(mapConfig.html.noInfo);
        }
    };


    /**
     * Reset all the marker icons to normal.
     *
     * @param {Object}
     */
    var resetIcons = function (markers) {
        markers.forEach(function (marker) {
            var mapIcon = {
                url: mapConfig.icons.goodcheer,
                size: new google.maps.Size(40, 64),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 32),
                scaledSize: new google.maps.Size(20, 32)
            };

            marker.setIcon(mapIcon);
        });
    };


    /**
     * Fit the bounds of the map to fit all of the markers.
     */
    var fitBounds = function () {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < markersOnMap.length; i++) {
            bounds.extend(markersOnMap[i].getPosition());
        }

        var northEast = bounds.getNorthEast();
        var southWest = bounds.getSouthWest();
        var center = bounds.getCenter();

        var latMultiplier = mapConfig.map.latMultiplier;
        var lngMultiplier = mapConfig.map.lngMultiplier;

        /**
         * Increase the distance between the center and the NE and SW points.
         */
        var latDiff = (northEast.lat() - center.lat()) * latMultiplier;
        var lngDiff = (northEast.lng() - center.lng()) * lngMultiplier;

        var northEastLat = center.lat() + latDiff;
        var southWestLat = center.lat() - latDiff;

        var northEastLng = center.lng() + lngDiff;
        var southWestLng = center.lng() - lngDiff;

        var newNorthEast = new google.maps.LatLng(northEastLat, northEastLng);
        var newSouthWest = new google.maps.LatLng(southWestLat, southWestLng);

        var newBounds = new google.maps.LatLngBounds(newSouthWest, newNorthEast);

        map.fitBounds(newBounds);
    };


    // jquery add-in to update filtering and dropdown functionality

    $(document).ready( function() {

      // FUNCTIONS

        function round_select2_containers() {
          
          $('.filters__item').each( function() {
            
            requestAnimationFrame( function() {
              $(this).css('width','');
              var my_width = $(this).width();
              $(this).css('width', Math.round(my_width) );
            });

          });

        }


      // EVENTS

         $('.filters__map__multiple').on('change', function (e) {

          // flatten object by concatting values
          function concatValues( obj ) {
            var value = '';
            for ( var prop in obj ) {
              value += obj[ prop ];
            }
            return value;
          }
          
          var my_filters = {};

          // multiple-value select option
          var type_value = $('#filter_type').val();
          filter.type = 'All';

          if ( $.isArray(type_value) && type_value.length > 0 ) {

            filter.type = [];
            $.each( $(type_value), function(item,value) {
              filter.type.push(value);  
            });
            
          }


          // console.log('type_value', type_value);

          var region_value = $('#filter_region').val();
          filter.region = 'All';

          if ( $.isArray(region_value) && region_value.length > 0 ) {

            filter.region = [];

            $.each( $(region_value), function(item,value) {
              filter.region.push(value);
            });
            
          }
          
          // console.log('filter', filter);

          updateMarkersOnMap();
          
          
        });



      // INIT

        // filter dropddowns

          var multiple_selection = $('.filters__map__multiple');

          if ( multiple_selection.length > 0 ) {
            round_select2_containers();
          }

          multiple_selection_select2 = multiple_selection.select2({
            width: '100%',
          });

          multiple_selection_select2.on('select2:opening select2:closing', function( event ) {
            var $searchfield = $(this).parent().find('.select2-search__field');
            $searchfield.prop('disabled', true);
          });

          multiple_selection.on('change', function() {
            
            var $selected = $(this).find('option:selected');
            var $container = $('.filters__results--' + $(this).data('taxonomy') );

            var search_concat = '';
            
            var $list = $('<ul class="filters__results__list  group">');
            $selected.each(function(k, v) {
              var $li = $('<li class="filters__results__list__item  tag-selected"><a class="filters__results__list__remove">×</a>' + $(v).text() + '</li>');
              
              $li.children('a.filters__results__list__remove')
                .off('click.select2-copy')
                .on('click.select2-copy', function(e) {
                  var $opt = $(this).data('select2-opt');
                  $opt.attr('selected', false);
                  $opt.parents('select').trigger('change');
                }).data('select2-opt', $(v));

              $list.append($li);

              search_concat += $(v).text() + ', ';

            });

            $container.html('').append($list);

            search_concat = search_concat.replace(/,\s*$/, "");

            updateMarkersOnMap();

          });


        // hash navigation check
          if( window.location.hash ) {
            
            var my_anchor = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

            // test for trail stops
            if ( my_anchor === 'beer' ||  my_anchor === 'biere' || my_anchor === 'cider' || my_anchor === 'cidre' || my_anchor === 'spirits' || my_anchor === 'spiritueux' || my_anchor === 'wine' || my_anchor === 'vin' || my_anchor === 'mead' || my_anchor === 'hydromel' ) {
              
              var my_term_ids = [];

              if ( my_anchor === 'beer' ) {
                my_term_ids.push('brewery');
                my_term_ids.push('brewpub');
              }
              if ( my_anchor === 'biere' ) {
                my_term_ids.push('brasserie');
                my_term_ids.push('microbrasserie');
              }

              if ( my_anchor === 'cider' ) {
                my_term_ids.push('cidery');
              }
              if ( my_anchor === 'cidre' ) {
                my_term_ids.push('cidrerie');
              }

              if ( my_anchor === 'spirits' ) {
                my_term_ids.push('distillery');
              }
              if ( my_anchor === 'spiritueux' ) {
                my_term_ids.push('distillerie');
              }

              if ( my_anchor === 'mead' ) {
                my_term_ids.push('meadery');
              }
              if ( my_anchor === 'hydromel' ) {
                my_term_ids.push('hydromellerie');
              }

              if ( my_anchor === 'wine' ) {
                my_term_ids.push('winery');
              }
              if ( my_anchor === 'vin' ) {
                my_term_ids.push('cave-viticole');
              }


              // console.log('my_term_ids', my_term_ids);
              var my_select = $('#filter_type')[0];

              $(my_term_ids).each( function( item, value ) {
                
                for (var i = 0; i < my_select.length; i++) {
                  if(my_select.options[i].value == value) {
                    my_select.options[i].selected = true;
                  } else {
                    // my_select.options[i].selected = false;
                  }
                }

              });

              $('#filter_type').trigger('change');
              // console.log( 'my_select', my_select.val() );

            }

          }


    });


    /* -- */


    /**
     * Main initialization function.
     *
     * @returns {void}
     */
    that.start = function () {
        addEventsToFilters();
        initGoogleMaps();
        updateMarkersOnMap();
    };


    /**
     * ...
     *
     * @param {String} info
     *
     * @returns {void}
     */
    that.updateInformation = function (info) {
        document.getElementById("vendorInformation").innerHTML = info;
    };


    /**
     * ...
     *
     * @param {Object} marker
     */
    that.selectMarker = function (marker) {
        var mapIcon = {
            url: mapConfig.icons.goodcheer,
            size: new google.maps.Size(40, 64),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 36),
            scaledSize: new google.maps.Size(24, 36)
        };
        var infoBox = document.querySelector("#vendorInformation");
        infoBox.classList.remove(infoBoxAnim);

        resetIcons(markersOnMap);

        that.updateInformation(marker.info);

        marker.setIcon(mapIcon);
        marker.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(function () {
            infoBox.classList.add(infoBoxAnim);

            marker.setAnimation(null);
        }, 700);

        currentlyDisplayedMarker = marker;
    };

    return that;
})(mapConfig);


/**
 * Map Data Model.
 *
 * --------------------------------------------------------------------------- *
 */
var MapModel = (function (mapConfig) {
    "use strict";

    var that = {};
    var vendor = [];
    var allMarkers;
    // var data = vendorData;

    var data = $("#map__vendors").data('vendors');


    
    /**
     * Vendor details (InfoBox)
     *
     * @param {Object} vendor
     *
     * @returns {String}
     */
    var vendorDetails = function (vendor) {

        var details = "<p>Information not currently available.</p>";

        if (typeof vendor === "object") {
            var city, country, email, facebook, gplus, instagram, logo, name, phone, postal, profile, province,
                streetAddress, twitter, vimeo, youtube = "";

            logo = '';
            if ( vendor.logo !== undefined ) {
                logo = "<img src=\""+ vendor.logo +"\" alt=\""+ name +"\">";    
            }

            if (exists(vendor.post_title) || vendor.post_title !== "") {
                name = "<h5>"+ vendor.name +"</h5>";
            }

            if (exists(vendor.streetAddress) && vendor.streetAddress !== "") {
                streetAddress = "<span itemprop=\"streetAddress\">"+ vendor.streetAddress +"</span>";
            }

            if (exists(vendor.address2) && vendor.address2 !== "") {
                streetAddress += ", <span itemprop=\"streetAddress\">"+ vendor.address2 +"</span>";
            }

            if (exists(vendor.city) && vendor.city !== "") {
                city = "<span itemprop=\"addressLocality\">"+ vendor.city +"</span>";
            }

            if (exists(vendor.province) && vendor.province !== "") {
                province = ", <span itemprop=\"addressRegion\">"+ vendor.province +"</span><br>";
            }

            country = "<span itemprop=\"country\">Canada</span>";

            if (exists(vendor.postal) && vendor.postal !== "") {
                postal = " <span itemprop=\"postalCode\">"+ vendor.postal +"</span><br>";
            }

            if (exists(vendor.phone) && vendor.phone !== "") {
                phone = "<span itemprop=\"telephone\" content=\""+ vendor.phone +"\"><strong>Tel:</strong> ";
                phone += vendor.phone +"</span>";
            }

            if (exists(vendor.tollfree) && vendor.tollfree !== "") {
                phone += "<br><span itemprop=\"telephone\" content=\""+vendor.tollfree +"\">";
                phone += "<strong>Toll Free:</strong> "+ vendor.tollfree +"</span>";
            }

            if (vendor.guid !== "") {
                profile = "<span rel=\"bookmark\" itemprop=\"url\">";
                profile += "<a itemprop=\"link\" rel=\"url\" href=\""+ vendor.guid +"\"";
                profile += " title=\" Visit the profile of ";

                if ( $('body').hasClass('lang--fr') ) {
                    profile += vendor.post_title +"\"><strong>En savoir plus</strong></a></span>";
                }
                else {
                    profile += vendor.post_title +"\"><strong>Learn More</strong></a></span>";
                }
            }

            details = logo;
            details += "<figcaption class=\"vendor-details\">"+ name;
            details += "<address itemscope itemtype=\"https://schema.org/PostalAddress\" itemprop=\"address\">";
            details += streetAddress +"<br>" + city + province + country + postal + phone;
            details += "</address>";
            details += "<nav class=\"vendor-social\">"+ profile +"</nav>";
            details += "</figcaption>";
        }

        return details;
    };


    /**
     * Turn the data into Maps Markers. For each marker we add a new function
     * that will display the info.
     */
    var createMarkers = function () {

        /**
         * ...
         *
         * @param {Object} marker
         *
         * @returns {Method}
        */
        var attachMarker = function (marker) {
            return function () {
                mappingApp.selectMarker(marker);
            };
        };

        allMarkers = [];

        var i, length;
        for (i = 0, length = data.length; i < length; i++) {
            vendor = data[i];
            vendor.animation = mapConfig.map.animation;

            var mapIcon = {
                url: mapConfig.icons.goodcheer,
                size: new google.maps.Size(40, 64),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 32),
                scaledSize: new google.maps.Size(20, 32)
            };

            var newMarker = new google.maps.Marker({
                animation: google.maps.Animation.DROP,
                position: new google.maps.LatLng(vendor.latitude, vendor.longitude),
                region: vendor.region.slug,
                type: (vendor.type).map(function (type, i) {
                    return type.slug;
                }),
                info: vendorDetails(vendor)
            });

            newMarker.setIcon(mapIcon);

            google.maps.event.addListener(newMarker, "click", attachMarker(newMarker, vendor));

            allMarkers.push(newMarker);
        }
    };


    /**
     * ...
     *
     * @param {Array}            markers
     * @param {String}           property
     * @param {Integer}|{String} value
     *
     * @returns {Array}
     */
    var filterMarkersOnPropertyValue = function (markers, property, value) {

        if (value === "All" || value === '0') {
            return markers;
        }

        /**
         * If the marker does not have the correct property, remove it from
         * the list.
         */
        var i, length, j, arr_length;
        var markersToPlace = [];
        for (i = 0, length = markers.length; i < length; i += 1) {
            if (value === markers[i][property] || (markers[i][property]).indexOf(value) >= 0) {
                markersToPlace.push(markers[i]);
            }

            if ( $.isArray(value) ) {
            
              for (j = 0, arr_length = value.length; j < arr_length; j += 1) {

                if (value[j] === markers[i][property] || (markers[i][property]).indexOf( value[j] ) >= 0) {
                    markersToPlace.push(markers[i]);
                }

              }

            }   


        }

        console.log('markersToPlace', markersToPlace);

        return markersToPlace;
    };


    /**
     * ...
     *
     * @param {String} value
     * @param {Array}  array
     *
     * @returns {Boolean}
     */
    var valueInArray = function (value, array) {
        var i, length;
        var inArray = false;
        for (i = 0, length = array.length; i < length && !inArray; i += 1) {
            if (array[i] === value) {
                inArray = true;
            }
        }

        return inArray;
    };


    /**
     * ...
     *
     * @param {Object} filterObject
     *
     * @returns {Object}
     */
    that.getMarkers = function (filterObject) {
        var markersToPlace;

        /**
         * Create markers from the data if we haven't already.
         */
        if (!allMarkers) {
            createMarkers();
        }

        /**
         * Fill with all markers initially.
         */
        markersToPlace = allMarkers;

        /**
         * Filters.
         */
        for (var property in filterObject ) {

            var filterValue = filterObject[property] || "All";
            markersToPlace = filterMarkersOnPropertyValue(markersToPlace, property, filterValue);
        }

        return markersToPlace;
    };

    return that;
})(mapConfig);


/**
 * Launch our trails mapping mappingApp.
 */
mappingApp.start();

/* <> */




